import about from './about.json';
import common from './common.json';
import header from './header.json';
import result from './result.json';
import stats from './stats.json';
import validation from './validation.json';

export const en = {
  about,
  common,
  header,
  result,
  stats,
  validation,
};
